import { render } from "./ModuleComponent.vue?vue&type=template&id=41c9b6a9&ts=true"
import script from "./ModuleComponent.vue?vue&type=script&lang=ts"
export * from "./ModuleComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__